import { type IGetRegisteredCompaniesQuery } from 'application/querySchemas/IGetRegisteredCompaniesQuery';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import {
    type IGetRegisteredCompaniesClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IGetRegisteredCompaniesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class GetRegisteredCompaniesQuery implements IGetRegisteredCompaniesQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IGetRegisteredCompaniesClient')
        public readonly getRegisteredCompaniesClient: IGetRegisteredCompaniesClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.getRegisteredCompaniesClient.get({
            token: this.supportUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
